import {
  CLEAR_ANNOUNCEMENT_NOTIFICATION_ID,
  SET_UNREAD_ANNOUNCEMENT_COUNT,
  TOGGLE_STUDENT_ANNOUNCEMENTS_SIDEBAR
} from 'actions/announcements'

const initialState = {
  unreadCount: 0,
  displayStudentSidebar: false,
  notificationId: null
}

export function announcements(
  state: Object = initialState,
  action: Object
): Object {
  switch (action.type) {
    case CLEAR_ANNOUNCEMENT_NOTIFICATION_ID: {
      return Object.assign({}, state, {
        notificationId: null
      })
    }

    case SET_UNREAD_ANNOUNCEMENT_COUNT: {
      return Object.assign({}, state, {
        unreadCount: action.payload.count
      })
    }

    case TOGGLE_STUDENT_ANNOUNCEMENTS_SIDEBAR: {
      return Object.assign({}, state, {
        displayStudentSidebar: action.payload.display,
        notificationId: action.payload.display
          ? action.payload.notificationId
          : null
      })
    }

    default:
      return state
  }
}
